module.exports = __webpack_public_path__ + "static/img/weezie_fiber_extended_blue.025628d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/weezie_fiber_extended_blue.png
// module id = ./src/assets/logos/weezie_fiber_extended_blue.png
// module chunks = 1